import { connect } from "react-redux";
import QueueComponent from "../../../Components/DashboardComponent/Body/QueueComponent";
const mapStateToProps = (state) => ({
   
});
const mapDispatchToProps = (dispatch) => ({
});
 
export default connect(mapStateToProps, mapDispatchToProps)(QueueComponent);